/* template */
<template><div :style="[(warpStyle)] | transRpxStyle" class="warp"><template v-if="(!error)"><mpx-text :style="[(ruleStyle)] | transRpxStyle" @tap="gotoLink(pageConfig.rule.link)" class="rule">规则</mpx-text><mpx-image webp :src="(pageConfig.header.image2)" mode="widthFix" class="header-image"/><red-packet-open :template="(info.template)" :btnText="(btnText)" :couponList="(couponList)" @couponClick="couponToUse" @click="toUseCoupon" v-if="(hasGetCoupon && hasCoupon && couponList)"/><red-packet-close :config="(pageConfig.redPacket)" :couponInfo="(activityCouponInfo)" :template="(info.template)" :btnText="(btnText)" @click="getCoupon" v-else-if="(activityCouponInfo || pageConfig)"/><image-list :imageList="(pageConfig.imageList)"/><res-banner :template="(info.template)" v-if="(activityCouponInfo)"/></template><error-view :message="(errmsg)" v-else/><popup-result :popupData="(popupResult)" :pageConfig="(pageConfig)" @close="popupClose" @click="popupClick" v-if="(popupResult)"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m05f76066"}'>
  @font-face {
    font-family: DIN-Bold-self;
    src: url(https://dpubstatic.udache.com/static/dpubimg/5e78fa44-928b-4132-aa31-d5bac7b67ece.ttf);
  }
  .warp
    min-height 100vh
    padding-bottom 180rpx
    overflow hidden
    font-size: 0;
    box-sizing: border-box;
    position: relative
    line-height: normal;
    .rule
      position absolute
      right 0
      border-radius: 100rpx 0 0 100rpx;
      font-family: PingFangSC-Semibold;
      font-size: 24rpx;
      letter-spacing: 1rpx;
      font-weight: bold
      padding 4rpx 16rpx 4rpx 25rpx
    .header-image
      width: 750rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m05f76066"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex05f76066%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./index.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Findex05f76066%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m05f76066"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index05f76066/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'error-view':()=>import(/* webpackChunkName: "error-view" */"../../components/common/error-view.mpx?async=error-view&isComponent&outputPath=components%2Ferror-view6fe98fb7%2Findex").then(res => getComponent(res)),'image-list':getComponent(require("../../components/common/image-list.mpx?isComponent&outputPath=components%2Fimage-list73d9d186%2Findex")),'res-banner':getComponent(require("../../components/common/res-banner.mpx?isComponent&outputPath=components%2Fres-banner12bfcde6%2Findex")),'red-packet-close':getComponent(require("../../components/common/red-packet-close.mpx?isComponent&outputPath=components%2Fred-packet-close937b2cc8%2Findex")),'red-packet-open':getComponent(require("../../components/common/red-packet-open.mpx?isComponent&outputPath=components%2Fred-packet-open09b1ea94%2Findex")),'popup-result':getComponent(require("../../components/hxz/popup-result.mpx?isComponent&outputPath=components%2Fpopup-result004a2ee8%2Findex")),'mpx-text':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-text.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
